import { REQUEST_SIGNUP, REQUEST_SIGNUP_FAILED, RESEND_APPROVE_EMAIL } from '../constants/index';
import { SignUpPayloadType, requestSignupSuccess } from '../actions/signUpActions';
import { call, put, takeEvery } from 'redux-saga/effects';
import { ActionType } from '../actions/themeActions';
import { ParsedResponseType } from '../../types/reduxTypes';
import authErrors from '../../constants/authErrors';
import config from '../../shared/config';
import generateAuthError from '../../services/error.parser';
const { signUpUrl, executeUrl } = config;

function* signUpHandler(action: ActionType<SignUpPayloadType>) {
  const { email, password } = action.payload;
  try {
    const signUpResponse: Response = yield call(fetch, signUpUrl, {
      body: JSON.stringify({
        password: password,
        username: email,
      }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
    });
    if (signUpResponse.status !== 201) {
      const parsedError: ParsedResponseType = yield call([signUpResponse, 'json']);
      throw parsedError;
    } else {
      yield put(requestSignupSuccess());
    }
  } catch (error) {
    yield put({
      payload: { message: generateAuthError({ error, errors: authErrors, unhandledErrorMessage: 'signUp error' }) },
      type: REQUEST_SIGNUP_FAILED,
    });
  }
}

function* resendEmail() {
  try {
    const signUpResponse: Response = yield call(fetch, executeUrl, {
      body: JSON.stringify({
        actionType: 'verify-email',
        username: null,
      }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
    });
    return signUpResponse;
  } catch (error) {
    console.error('resendEmail', error);
  }
}

export default function* fetchUserWatcher(): Generator {
  yield takeEvery(REQUEST_SIGNUP, signUpHandler);
  yield takeEvery(RESEND_APPROVE_EMAIL, resendEmail);
}
